import { PropsWithChildren } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { Drawer, SideNavbarWrapper } from './SideNavbar.styles';
import { SideNavExpandedProvider } from './SideNavExpandedContext';

export interface SideNavbarProps {
  readonly open?: boolean;
  readonly onClose?: () => void;
  readonly onMouseOver?: () => void;
}

export function SideNavbar({
  open,
  onClose,
  onMouseOver,
  children,
}: PropsWithChildren<SideNavbarProps>) {
  const { isMdUp } = useBreakpoints();

  const expanded = Boolean(open);

  if (isMdUp) {
    return (
      <Drawer
        anchor="left"
        onClose={onClose}
        onMouseLeave={onClose}
        onMouseOver={onMouseOver}
        open={open}
        variant="permanent"
      >
        <SideNavExpandedProvider expanded={expanded}>
          <SideNavbarWrapper>{children}</SideNavbarWrapper>
        </SideNavExpandedProvider>
      </Drawer>
    );
  }

  return (
    <Drawer anchor="left" onClose={onClose} open={open}>
      <SideNavExpandedProvider expanded={expanded}>
        <SideNavbarWrapper>{children}</SideNavbarWrapper>
      </SideNavExpandedProvider>
    </Drawer>
  );
}
